import { SignupForm } from 'mk2/apps/users/components/SignupForm';
import { SignupLoginWrapper } from 'mk2/apps/users/components/SignupLoginWrapper';
import { Props } from 'mk2/apps/users/containers/Signup/SignupPage';
import * as React from 'react';
import styles from './Signup.mscss';

export default class Signup extends React.Component<Props> {

    public render() {
        const { location, onStoreEvent, query, initialValues } = this.props;

        return (
            <SignupLoginWrapper className={styles.Signup} qs={location.search}>
                <SignupForm
                    onStoreEvent={onStoreEvent}
                    query={query}
                    simple={false}
                    iframe={false}
                    onSignup={this.handleSignup}
                    initialValues={initialValues}
                />
            </SignupLoginWrapper>
        );
    }

    private handleSignup = (values) => {
        const { query, onSignup } = this.props;
        onSignup(values, query, false);
    };
}
